module.exports = __webpack_public_path__ + "assets/img/f5c2-mt.svg";